import AuditLogSummary from "./logs";

const AuditLogs = (data) => {
  console.log("apiData", data.data.auditLogs);
  const logData = data.data.auditLogs;
  return <AuditLogSummary logsArray={logData} />;
};

export default AuditLogs;
